export function formatCurrency(amount, locale = "en") {
  const number = Number(amount) || 0;
  return new Intl.NumberFormat(locale === "ar" ? "ar-EG" : "en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(number);
}

export function formatNumber(value, locale = "en") {
  const number = Number(value) || 0;
  return new Intl.NumberFormat(locale === "ar" ? "ar-EG" : "en-US").format(
    number
  );
}

export function formatDate(date, locale = "en") {
  if (!date) return "";
  return new Date(date).toLocaleDateString(
    locale === "ar" ? "ar-EG" : "en-US",
    {
      year: "numeric",
      month: "short",
      day: "numeric",
    }
  );
}

export function formatBookingStatus(status) {
  switch (status) {
    case "completed":
      return {
        class: "bg-green-500/10 text-green-500 border border-green-500/20",
        textKey: "completed",
      };
    case "pending":
      return {
        class: "bg-amber-500/10 text-amber-500 border border-amber-500/20",
        textKey: "pending",
      };
    case "confirmed":
      return {
        class: "bg-blue-500/10 text-blue-500 border border-blue-500/20",
        textKey: "confirmed",
      };
    case "cancelled":
      return {
        class: "bg-red-500/10 text-red-500 border border-red-500/20",
        textKey: "cancelled",
      };
    case "rejected":
      return {
        class: "bg-orange-500/10 text-orange-500 border border-orange-500/20",
        textKey: "rejected",
      };
    default:
      return {
        class: "bg-slate-500/10 text-slate-500 border border-slate-500/20",
        textKey: status || "unknown",
      };
  }
}
